(() => {
  'use strict';
  if (window.OleaWishlistAccountSync) return;
  const guestIntentKey='olea:wishlist:guest-import:v2:ksazx7-h1.myshopify.com';
  const handlePattern=/^[a-z0-9][a-z0-9-]{0,254}$/;
  let owner='guest',generation=0,baseline=null,running=null,rerun=false,applying=false,timer,connecting=false,state='guest';
  const api=()=>window.OleaPortalCustomerAPI;
  const store=()=>window.OleaWishlist;
  const config=()=>document.querySelector('[data-op-portal][data-op-client-id]')||document.querySelector('#OleaCustomerConfig');
  const enabled=()=>(document.querySelector('#OleaCustomerConfig')?.dataset.opSyncEnabled??config()?.dataset.opSyncEnabled)!=='false';
  const currentOwner=()=>String(store()?.getOwner?.() ?? store()?.owner ?? 'guest');
  const nativeOwner=()=>String(config()?.dataset.opCustomerId || 'guest');
  const verifiedOwner=()=>api()?.isAuthenticated?.()===true&&api()?.verifiedCustomerId===owner;
  const signedInOwner=()=>/^\d+$/.test(owner)&&currentOwner()===owner&&((nativeOwner()===owner&&config()?.dataset.opAuthenticated==='true')||verifiedOwner());
  const eligible=()=>enabled()&&signedInOwner()&&(api()?.customerId===owner||verifiedOwner());
  const authenticated=()=>eligible()&&api()?.favoritesConfigured&&api()?.isAuthenticated();
  const defaults={disabled:'',guest:'Connectez-vous pour retrouver vos favoris sur vos appareils.',connect:'Vos favoris sont conservés sur cet appareil. Synchronisez-les avec votre compte.',syncing:'Synchronisation de vos favoris…',saved:'Vos favoris sont synchronisés avec votre compte.',error:'La synchronisation n’a pas pu être confirmée. Vos favoris sont conservés.',conflict:'Votre sélection a changé sur un autre appareil. Réessayez.',limit:'Vos sélections sont conservées. Réduisez leur nombre avant de les réunir.'};
  const status=(next,code='')=>{
    state=next;
    const connected=signedInOwner();
    document.querySelectorAll('[data-wishlist-account-heading]').forEach(node=>{const text=connected&&enabled()?node.dataset.syncCustomer:node.dataset.syncGuest;if(text)node.textContent=text;});
    document.querySelectorAll('[data-wishlist-account-local]').forEach(node=>{node.hidden=connected&&enabled();});
    document.querySelectorAll('[data-wishlist-account-status]').forEach(node=>{node.textContent=node.dataset['sync'+next[0].toUpperCase()+next.slice(1)]??defaults[next]??defaults.error;node.dataset.state=next;node.hidden=next==='disabled';});
    document.querySelectorAll('[data-wishlist-account-connect]').forEach(node=>{node.textContent=connected?(node.dataset.labelSync||'Synchroniser mes favoris'):(node.dataset.labelConnect||'Connecter mon compte');node.disabled=connecting||next==='syncing';node.hidden=next==='disabled';node.setAttribute('aria-busy',String(connecting||next==='syncing'));});
    document.dispatchEvent(new CustomEvent('wishlist:sync',{detail:{state:next,code}}));
  };
  const failure=code=>Object.assign(new Error(code),{code});
  const itemList=value=>{
    if(!Array.isArray(value)||value.length>100)throw failure('limit');
    const seen=new Set();
    return value.map(item=>{
      if(!item||!handlePattern.test(item.handle)||seen.has(item.handle))throw failure('invalid_local');
      seen.add(item.handle);const variantId=item.variantId==null||item.variantId===''?null:String(item.variantId);
      if(variantId!==null&&!/^\d{1,30}$/.test(variantId))throw failure('invalid_local');
      return{handle:item.handle,variantId};
    });
  };
  const albumList=(value,items)=>{
    if(!Array.isArray(value)||value.length>20)throw failure('limit');
    const available=new Set(items.map(item=>item.handle)),ids=new Set();
    return value.map(album=>{
      if(!album||typeof album.id!=='string'||!/^[A-Za-z0-9_-]{1,64}$/.test(album.id)||ids.has(album.id)||typeof album.name!=='string'||!album.name.trim()||album.name.trim().length>60||/[\u0000-\u001f\u007f]/.test(album.name)||!Array.isArray(album.handles)||album.handles.length>100)throw failure('invalid_local');
      ids.add(album.id);const handles=[...new Set(album.handles)];
      if(handles.some(handle=>typeof handle!=='string'||!handlePattern.test(handle)||!available.has(handle)))throw failure('invalid_local');
      return{id:album.id,name:album.name.trim(),handles};
    });
  };
  const snapshot=(items,albums)=>{const selected=itemList(items);return{items:selected,albums:albumList(albums||[],selected)};};
  const local=()=>snapshot(store().get(),store().getAlbums());
  const equal=(left,right)=>JSON.stringify(left)===JSON.stringify(right);
  const mergeEntries=(base,left,right,key,combine)=>{
    const before=new Map((base||[]).map(item=>[item[key],item])),a=new Map(left.map(item=>[item[key],item])),b=new Map(right.map(item=>[item[key],item]));
    const result=[];
    for(const id of new Set([...a.keys(),...b.keys()])){
      const original=before.get(id),l=a.get(id),r=b.get(id);
      if(!original){result.push(l&&r?combine(null,l,r):l||r);continue;}
      if(!l){if(!equal(original,r))result.push(r);continue;}
      if(!r){if(!equal(original,l))result.push(l);continue;}
      result.push(combine(original,l,r));
    }
    return result;
  };
  const merge=(base,left,right)=>{
    const items=mergeEntries(base?.items,left.items,right.items,'handle',(before,l,r)=>!before||!equal(before,l)?l:r);
    if(items.length>100)throw failure('limit');
    const available=new Set(items.map(item=>item.handle));
    const albums=mergeEntries(base?.albums,left.albums,right.albums,'id',(before,l,r)=>{
      const membership=mergeEntries(before?.handles.map(handle=>({handle})),l.handles.map(handle=>({handle})),r.handles.map(handle=>({handle})),'handle',(old,a)=>a).map(item=>item.handle);
      return{id:l.id,name:!before||l.name!==before.name?l.name:r.name,handles:membership};
    }).map(album=>({...album,handles:album.handles.filter(handle=>available.has(handle))}));
    if(albums.length>20)throw failure('limit');
    return snapshot(items,albums);
  };
  const apply=value=>{
    const previous=new Map(store().get().map(item=>[item.handle,item]));
    const items=value.items.map(item=>({...previous.get(item.handle),...item}));
    applying=true;
    try{
      if(typeof store().replaceState==='function'){
        if(store().replaceState(items,value.albums)===false)throw failure('storage');
      }else{
        if(store().replace(items)===false)throw failure('storage');
        if(store().replaceAlbums(value.albums)===false)throw failure('storage');
      }
    }finally{applying=false;}
  };
  const sameGeneration=value=>value===generation&&authenticated();
  const sync=async()=>{
    if(!enabled()){status('disabled');return false;}
    if(!authenticated()){status(signedInOwner()?'connect':'guest');return false;}
    if(running){rerun=true;return running;}
    const started=generation;
    status('syncing');
    const request=(async()=>{
      try{
        for(let attempt=0;attempt<3;attempt++){
          const remote=await api().favorites();if(!sameGeneration(started))return false;
          if(String(remote.ownerId).replace(/^gid:\/\/shopify\/Customer\//,'')!==owner)throw failure('owner_changed');
          const remoteState=snapshot(remote.items,remote.albums),captured=local(),merged=merge(baseline,captured,remoteState);
          let saved=remoteState,savedDigest=remote.compareDigest;
          if(!equal(merged,remoteState)){
            try{
              const result=await api().setFavorites(merged.items,{albums:merged.albums,compareDigest:remote.compareDigest});
              if(!sameGeneration(started))return false;
              if(String(result.ownerId).replace(/^gid:\/\/shopify\/Customer\//,'')!==owner)throw failure('owner_changed');
              saved=snapshot(result.items,result.albums);savedDigest=result.compareDigest;
              if(!equal(saved,merged))throw failure('invalid_response');
            }catch(error){if(error?.code==='favorites_conflict'&&attempt<2)continue;throw error;}
          }
          if(!sameGeneration(started))return false;
          const latest=local(),reconciled=merge(captured,latest,saved);
          baseline=saved;apply(reconciled);if(!equal(reconciled,saved))rerun=true;
          status('saved');
          document.dispatchEvent(new CustomEvent('wishlist:remote-saved',{detail:{owner,items:saved.items,albums:saved.albums,compareDigest:savedDigest,source:'customer_account_api',savedAt:Date.now()}}));
          return true;
        }
      }catch(error){
        if(started!==generation)return false;
        const code=error?.code==='favorites_conflict'?'conflict':error?.code==='limit'?'limit':'error';
        status(code,code);return false;
      }
      return false;
    })();
    running=request;
    try{return await request;}
    finally{if(running===request)running=null;if(rerun&&authenticated()){rerun=false;clearTimeout(timer);timer=setTimeout(()=>void sync(),250);}}
  };
  const schedule=()=>{if(applying||!authenticated())return;clearTimeout(timer);timer=setTimeout(()=>void sync(),500);};
  const refreshOwner=()=>{
    const next=currentOwner();
    if(next!==owner){generation++;baseline=null;rerun=false;clearTimeout(timer);owner=next;}
    if(!enabled())status('disabled');else if(authenticated())void sync();else status(signedInOwner()?'connect':'guest');
  };
  const rememberGuestImport=()=>{
    try{sessionStorage.setItem(guestIntentKey,JSON.stringify({createdAt:Date.now(),path:location.pathname}));}catch{}
  };
  const importGuest=()=>{
    if(typeof store()?.importGuest!=='function')return;
    const guest=store().getGuest?.();
    const value=guest?snapshot(guest.items,guest.albums):null;
    if(value&&!value.items.length&&!value.albums.length)return;
    const key='olea:wishlist:guest-imported:v2:ksazx7-h1.myshopify.com:'+owner,fingerprint=value?JSON.stringify(value):'';
    try{if(fingerprint&&localStorage.getItem(key)===fingerprint)return;}catch{}
    if(value&&(new Set([...store().get().map(item=>item.handle),...value.items.map(item=>item.handle)]).size>100||new Set([...store().getAlbums().map(album=>album.id),...value.albums.map(album=>album.id)]).size>20))throw failure('limit');
    if(store().importGuest()===false)throw failure('storage');
    try{if(fingerprint)localStorage.setItem(key,fingerprint);}catch{}
  };
  const importRequestedGuest=()=>{
    if(owner==='guest'||typeof store()?.importGuest!=='function')return;
    let intent;try{intent=JSON.parse(sessionStorage.getItem(guestIntentKey)||'null');sessionStorage.removeItem(guestIntentKey);}catch{return;}
    if(intent?.path===location.pathname&&Number.isFinite(intent.createdAt)&&intent.createdAt<=Date.now()&&Date.now()-intent.createdAt<15*60*1000)importGuest();
  };
  const connect=async()=>{
    if(!enabled()){status('disabled');return false;}
    if(connecting)return false;connecting=true;
    try{
      if(!signedInOwner()){
        rememberGuestImport();
        const relative=location.pathname+location.search+location.hash;
        let login;try{login=new URL(config()?.dataset.opLoginUrl||'/customer_authentication/login',location.origin);}catch{login=new URL('/customer_authentication/login',location.origin);}
        if(login.origin!==location.origin||login.pathname!=='/customer_authentication/login')login=new URL('/customer_authentication/login',location.origin);
        login.searchParams.set('return_to',relative);location.assign(login.pathname+login.search);return false;
      }
      if(!eligible()||!api()?.favoritesConfigured)throw failure('not_configured');
      importGuest();
      await api().ensureAuthenticated({returnTo:location.href,intent:'favorites_sync'});
      return await sync();
    }catch(error){if(error?.code!=='authorization_redirect'){const code=error?.code==='limit'?'limit':'error';status(code,code);}return false;}
    finally{connecting=false;status(state);}
  };
  const initialize=()=>{
    owner=currentOwner();try{importRequestedGuest();}catch(error){status(error?.code==='limit'?'limit':'error');return;}refreshOwner();
  };
  document.addEventListener('wishlist:change',schedule);
  document.addEventListener('wishlist:albums-change',schedule);
  document.addEventListener('wishlist:owner-change',refreshOwner);
  document.addEventListener('op:api-ready',refreshOwner);
  document.addEventListener('op:api-cleared',()=>{generation++;baseline=null;rerun=false;clearTimeout(timer);status(signedInOwner()?'connect':'guest');});
  document.addEventListener('click',event=>{const button=event.target.closest?.('[data-wishlist-account-connect]');if(button){event.preventDefault();void connect();}});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden&&authenticated())void sync();});
  window.OleaWishlistAccountSync=Object.freeze({sync,connect,getState:()=>state});
  if(document.readyState==='complete')initialize();else document.addEventListener('DOMContentLoaded',initialize,{once:true});
})();
